

Bugsnag.metaData = {
    user: {
        username: "Bugsnag",
        email: "premium"
    }
};